<pr-display-colour-bar direction="vertical" [category]="category$ | async" />

<div
  *ngIf="eventable$ | async as eventable"
  class="header-row flex flex-1 flex-row items-center gap-4"
>
  <ng-container *ngIf="showPractitionerIcon">
    <ng-container *ngIf="practitioners$ | async as practitioners">
      <pt-user-icon
        *ngFor="let practitioner of practitioners; trackBy: trackByPractitioner"
        [diameter]="mediaDiameter"
        [name]="practitioner.user.name"
        [src]="practitioner | map: stafferProfileImage$ : this | async"
      />
    </ng-container>
  </ng-container>

  <pr-eventable-header-template
    class="flex-1"
    [start]="
      eventable.event.from
        | momentTimezone$: eventable.event.practice.ref
        | async
    "
    [end]="
      eventable.event.to | momentTimezone$: eventable.event.practice.ref | async
    "
  >
    <pr-eventable-next-stage
      *ngIf="nextStage$ | async as nextStage"
      [nextStage]="nextStage"
    />

    <div prEventableHeaderIcon>
      <pt-user-icon
        [diameter]="mediaDiameter"
        [name]="eventable.metadata.label"
        [src]="patientProfileImage$ | async"
      />
    </div>

    <div class="flex flex-col">
      <div prEventableHeaderTitle class="flex items-center gap-2">
        <h3 class="mat-headline-6">{{ eventable.metadata.label }}</h3>

        <pr-new-patient-icon
          [appointment]="eventable"
          [patient]="{ ref: eventable.metadata.patientRef }"
        />
      </div>

      <div>
        {{ eventable.metadata.treatmentPlanName }} -
        {{ eventable.metadata.treatmentStepName }}
      </div>

      <pr-eventable-tags-preview
        *ngIf="hasTags$ | async"
        [eventable]="eventable"
      />
    </div>
  </pr-eventable-header-template>

  <div
    class="flex items-center gap-4"
    (click)="$event.preventDefault(); $event.stopPropagation()"
  >
    <button
      *ngIf="accountSummary.outstanding$ | async as unpaidInvoiceAmount"
      mat-icon-button
      matTooltip="Outstanding {{ unpaidInvoiceAmount | currency }}"
    >
      <mat-icon class="alert-icon" color="warn">payments</mat-icon>
    </button>

    <pr-timeline-appointment-notifications
      [tooltipsEnabled]="true"
      [appointment]="eventable"
      [badgeSize]="24"
    />

    <div class="flex gap-2">
      @if (canCheckIn$ | async) {
        <ng-container
          *ngIf="
            checkInRequirementsCount$ | async as checkInRequirementsCount;
            else simpleCheckIn
          "
        >
          <button
            mat-stroked-button
            prExpansionDisable
            matTooltip="Check In steps required"
            matBadgeColor="primary"
            [matBadge]="checkInRequirementsCount"
            (click)="openArrival(eventable)"
          >
            Check In
          </button>
        </ng-container>
        <ng-template #simpleCheckIn>
          <button
            mat-stroked-button
            prExpansionDisable
            matTooltip="Check In"
            (click)="checkIn(eventable)"
          >
            Check In
          </button>
        </ng-template>
      }

      @if (startAppointmentVisible$ | async) {
        <button
          mat-stroked-button
          prExpansionDisable
          (click)="runAction(startAppointment, eventable)"
        >
          Start
        </button>
      }

      @if (openAppointmentVisible$ | async) {
        <button
          mat-stroked-button
          prExpansionDisable
          (click)="runAction(openAppointment, eventable)"
        >
          Open
        </button>
      }

      @if (canCheckOut$ | async) {
        <a
          mat-stroked-button
          prExpansionDisable
          matTooltip="Check Out"
          (click)="routeToCheckOut()"
        >
          Check Out
        </a>
      }

      @if (inProgress$ | async) {
        <button mat-stroked-button prExpansionDisable disabled>
          Check Out
        </button>
      }
    </div>

    <pr-appointment-menu
      prExpansionDisable
      [patient]="patient$ | async"
      [appointment]="eventable"
      (updateEventableStatus)="updateEventableStatus(eventable, $event)"
    />
  </div>
</div>
